import React from "react"
import "../Css_files/career_c3.css"

const OnlineLearningBenefits = () => {
  const benefits = [
    {
      icon: "🎓",
      title: "Certified Courses",
      description: "Gain industry-recognized certifications upon completing each course.",
    },
    {
      icon: "💡",
      title: "Expert Instructors",
      description: "Learn from professionals with years of experience in their respective fields.",
    },
    {
      icon: "🕒",
      title: "Flexible Learning",
      description: "Access courses anytime, anywhere at your own pace.",
    },
    {
      icon: "💻",
      title: "Hands-On Projects",
      description: "Work on real-world projects to apply your knowledge and build a strong portfolio.",
    },
    {
      icon: "🌐",
      title: "Global Community",
      description: "Connect with learners worldwide and collaborate on projects and discussions.",
    },
    {
      icon: "📚",
      title: "Continuous Learning",
      description: "Access new courses, resources, and learning paths regularly to stay ahead.",
    },
  ]

  const testimonials = [
    {
      name: "Arun Kumar",
      role: "Mechanical Engineering Student",
      course: "Mechanical Engineering",
      quote:
        "The hands-on projects and expert guidance helped me master mechanical concepts. I feel confident to take on real-world challenges.",
      avatar: "👨‍🎓",
    },
    {
      name: "Priya Ramesh",
      role: "Civil Engineering Student",
      course: "Civil Engineering",
      quote:
        "The platform's interactive content and practical exercises made learning enjoyable and effective.",
      avatar: "👩‍🎓",
    },
    {
      name: "Karthik Venkatesh",
      role: "Digital Arts Student",
      course: "Arts & Multimedia",
      quote:
        "From animation to 3D modeling, the courses helped me develop skills that I can showcase in my portfolio.",
      avatar: "👨‍🎨",
    },
  ]

  return (
    <section className="career-benefits" id="learning-benefits">
      <div className="career-benefits-container">
        <div className="career-benefits-header">
          <h2 className="career-benefits-title">Why Choose Profenaa Online?</h2>
          <p className="career-benefits-subtitle">
            Our platform is designed to empower learners with practical skills and real-world knowledge.
          </p>
        </div>

        <div className="career-benefits-grid">
          {benefits.map((benefit, index) => (
            <div key={index} className="career-benefit-card">
              <div className="career-benefit-icon">{benefit.icon}</div>
              <h3 className="career-benefit-title">{benefit.title}</h3>
              <p className="career-benefit-description">{benefit.description}</p>
            </div>
          ))}
        </div>

        <div className="career-testimonials">
          <h3 className="career-testimonials-title">What Our Learners Say</h3>
          <div className="career-testimonials-grid">
            {testimonials.map((testimonial, index) => (
              <div key={index} className="career-testimonial-card">
                <div className="career-testimonial-avatar">{testimonial.avatar}</div>
                <blockquote className="career-testimonial-quote">"{testimonial.quote}"</blockquote>
                <div className="career-testimonial-author">
                  <div className="career-testimonial-name">{testimonial.name}</div>
                  <div className="career-testimonial-role">{testimonial.role}</div>
                  <div className="career-testimonial-department">{testimonial.course}</div>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="career-culture">
          <div className="career-culture-content">
            <h3 className="career-culture-title">Our Learning Philosophy</h3>
            <p className="career-culture-description">
              Profenaa Online promotes a culture of curiosity, creativity, and continuous improvement.
              Our learners are empowered to take charge of their education, explore new disciplines, and build skills 
              that have real-world impact.
            </p>
            <div className="career-culture-values">
              <div className="career-culture-value">
                <span className="career-culture-value-icon">🚀</span>
                <span>Innovation</span>
              </div>
              <div className="career-culture-value">
                <span className="career-culture-value-icon">🤝</span>
                <span>Collaboration</span>
              </div>
              <div className="career-culture-value">
                <span className="career-culture-value-icon">🎯</span>
                <span>Excellence</span>
              </div>
              <div className="career-culture-value">
                <span className="career-culture-value-icon">🌱</span>
                <span>Continuous Growth</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default OnlineLearningBenefits
